import * as React from "react"

export const FunctionsIcon = ({
  width = 40,
  height = 40,
  ...rest
}: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...rest}
    width={width}
    height={height}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width={width} height={height} rx="8" fill="#F9F2FF" />

    <path
      d="M13 28L18.2 15.91L17.175 14H15.5V12H18C18.525 12 18.975 12.26 19.1625 12.63L26.325 26H28V28H25.5C24.9625 28 24.5125 27.73 24.3375 27.36L19.6625 18.65L15.65 28H13Z"
      fill="#7026B9"
      stroke="#F9F2FF"
      strokeWidth="0.75"
    />
  </svg>
)
